import { RequiredNonNull } from './required-non-null';

export type WithRequiredPropsNonNull<T, K extends keyof T> = RequiredNonNull<Pick<T, K>> & T;

export function hasRequiredPropsNonNull<T extends object | Record<keyof never, unknown>, K extends keyof T>(
    obj: T | null | undefined,
    ...keysToCheck: K[]
): obj is WithRequiredPropsNonNull<T, K> {
    return obj !== null && obj !== undefined && keysToCheck.every(key => obj[key] !== null && obj[key] !== undefined);
}
